/** Missing UTC calendar days, coalesced into inclusive ranges for the live endpoint.
 * A cached zero is covered; a missing day is unknown, including holes inside a window.
 */
export function findMissingDateRanges(
    start: string,
    end: string,
    cachedDates: ReadonlySet<string>,
): [string, string][] {
    const gaps: [string, string][] = [];
    let gap: [string, string] | undefined;
    for (let ms = Date.parse(`${start}T00:00:00Z`), last = Date.parse(`${end}T00:00:00Z`);
        ms <= last; ms += 86400000) {
        const date = new Date(ms).toISOString().slice(0, 10);
        if (cachedDates.has(date)) {
            gap = undefined;
        } else if (gap) {
            gap[1] = date;
        } else {
            gap = [date, date];
            gaps.push(gap);
        }
    }
    return gaps;
}
